import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import type { FC, ReactNode } from 'react';

type Props = FlexProps & { children: ReactNode; backgroundContent?: ReactNode };

export const appPageProps: Omit<Props, 'children'> = {
  flexDirection: { base: 'column', lg: 'row' },
  justifyContent: { lg: 'space-between' },
  pt: '80px',
  pb: { base: '40px' },
  columnGap: 0,
};

export const LayoutSectionCard: FC<Props> = ({ children, backgroundContent, ...flexProps }) => (
  <>
    <Flex w="full" position="relative" overflow="hidden">
      {backgroundContent && backgroundContent}
      <Flex
        mx="auto"
        gap="40px"
        flexDirection="column"
        py={{ base: '40px', lg: '120px' }}
        px={{ base: '16px', lg: '24px', xl: '40px' }}
        w={{ base: '100%', xl: '1366px' }}
        {...flexProps}
      >
        {children}
      </Flex>
    </Flex>
  </>
);
